// var playlist = ATPlaylist ? ATPlaylist : "";
// var player = ATPlayer ? ATPlayer : "";

var can_append = true;
let screen_size = 400;

if ($("#page-wrapper").length > 0) {
  screen_size =
    $(window).outerWidth() > 768
      ? parseInt($("#page-wrapper").outerHeight() * 0.5)
      : parseInt($("#page-wrapper").outerHeight() * 0.25);

  if ($(".DM-embed").length > 0) {
    if ($(".DM-embed").hasClass("small-embed")) {
      screen_size = 400;
    }
  }
}

function prepareDMPlayer() {
  can_append = false;

  $(".DM-embed").removeClass("hidden");

  var script = document.createElement("script");
  script.onload = function () {
    return;
  };
  script.src = `https://geo.dailymotion.com/player/${ATPlayer}.js`;
  script.setAttribute("data-playlist", `${ATPlaylist}`);

  document.getElementById("DM-embed-player").appendChild(script);
}

$(window).on("scroll", function () {
  if (document.getElementById("DM-embed-player")) {
    if (ATPlayer && ATPlaylist) {
      if ($(window).scrollTop() >= screen_size) {
        if (can_append) {
          prepareDMPlayer();
        }
      }
    }
  }
});
